import { forwardRef, useCallback, useMemo } from "react";
import { useQueryParams } from "../../dataAccess/QueryParams";
import {
  Partner,
  PartnerResponse,
  usePartners,
} from "../../dataAccess/api/partners";
import Filter, {
  FilterCommonSettings,
  FilterCommonProps,
  Option,
} from "../ui/Filter";
import { PublicComponentProps } from "./PublicComponentProps";
import { GridSettings } from "./Grid";

interface Settings extends FilterCommonSettings {
  isOpenOnMobile?: boolean;
  isOpenOnDesktop?: boolean;
}
// TODO: remove "any" type in the next lines
interface Props
  extends Pick<FilterCommonProps, "mobile">,
    PublicComponentProps<Settings, any, any, GridSettings> {
  partnerList?: PartnerResponse;
}
const PartnersFilter = forwardRef(
  ({ partnerList, settings, mobile }: Props, ref) => {
    const { partner_ids } = useQueryParams();
    const { loadingPartnerList } = usePartners();
    const partnerToOption = useCallback(
      ({ id: value, name: label, numberOfItems }: Partner): Option => ({
        value: String(value),
        label,
        detailsLabel: settings.showNumberOfResults
          ? String(numberOfItems || "")
          : "",
      }),
      [settings],
    );
    const defaultExpanded = useMemo(() => {
      if (partner_ids && partner_ids?.length > 0) {
        return true;
      }
      return mobile ? settings.isOpenOnMobile : settings.isOpenOnDesktop;
    }, [partner_ids]);

    return partnerList || loadingPartnerList ? (
      <Filter
        ref={ref}
        alignment={settings.alignment}
        options={[{ values: partnerList?.map(partnerToOption) || [] }]}
        title={settings.title || "Partners"}
        queryParam="partner_ids"
        variant={
          settings.position !== "vertical" ? "horizontal" : settings.position
        }
        mobile={mobile}
        loading={loadingPartnerList}
        defaultExpanded={defaultExpanded}
        horizontalVariant={settings.horizontalVariant}
      />
    ) : null;
  },
);

export default PartnersFilter;
